import GLTransitions from "gl-transitions";

function getPushLeft() {
  const str =
    "uniform vec2 direction; \
  vec4 transition (vec2 uv) { \
    vec2 p = uv + progress * sign(direction); \
    vec2 f = fract(p); \
    return mix( \
      getToColor(f), \
      getFromColor(f), \
      step(0.0, p.y) * step(p.y, 1.0) * step(0.0, p.x) * step(p.x, 1.0)); \
  } ";

  let transitionSpec = {
    glsl: str,
    name: "Directional",
    paramsTypes: { directional: "vec2" },
    defaultParams: { direction: [1, 0] },
  };
  return Object.freeze(transitionSpec);
}

function getPushRight() {
  let str =
    "uniform vec2 direction;  \
  vec4 transition (vec2 uv) { \
    vec2 p = uv + progress * sign(direction); \
    vec2 f = fract(p); \
    return mix( \
      getToColor(f), \
      getFromColor(f), \
      step(0.0, p.y) * step(p.y, 1.0) * step(0.0, p.x) * step(p.x, 1.0)); \
  } ";

  const transitionSpec = {
    glsl: str,
    name: "Directional",
    paramsTypes: { directional: "vec2" },
    defaultParams: { direction: [-1, 0] },
  };
  return Object.freeze(transitionSpec);
}

function getPushTop() {
  const str =
    "uniform vec2 direction;  \
  vec4 transition (vec2 uv) { \
    vec2 p = uv + progress * sign(direction); \
    vec2 f = fract(p); \
    return mix( \
      getToColor(f), \
      getFromColor(f), \
      step(0.0, p.y) * step(p.y, 1.0) * step(0.0, p.x) * step(p.x, 1.0)); \
  } ";

  let transitionSpec = {
    glsl: str,
    name: "Directional",
    paramsTypes: { directional: "vec2" },
    defaultParams: { direction: [0, -1] },
  };
  return Object.freeze(transitionSpec);
}

function getPushBottom() {
  const str =
    "uniform vec2 direction;  \
  vec4 transition (vec2 uv) { \
    vec2 p = uv + progress * sign(direction); \
    vec2 f = fract(p); \
    return mix( \
      getToColor(f), \
      getFromColor(f), \
      step(0.0, p.y) * step(p.y, 1.0) * step(0.0, p.x) * step(p.x, 1.0)); \
  } ";

  let transitionSpec = {
    glsl: str,
    name: "Directional",
    paramsTypes: { directional: "vec2" },
    defaultParams: { direction: [0, 1] },
  };
  return Object.freeze(transitionSpec);
}

function getRadial() {
  const str =
    "uniform float startingAngle; \
            vec4 transition (vec2 uv) { \
              float PI = 3.141592653589; \
              float offset = startingAngle * PI / 180.0; \
              float angle = atan(uv.y - 0.5, uv.x - 0.5) + offset; \
              float normalizedAngle = (-angle + PI) / (2.0 * PI); \
              normalizedAngle = normalizedAngle - floor(normalizedAngle); \
              return mix( \
                getFromColor(uv), \
                getToColor(uv), \
                step(normalizedAngle, progress) \
                ); \
            } ";

  let transitionSpec = {
    glsl: str,
    name: "angular",
    paramsTypes: { startingAngle: "float" },
    defaultParams: { startingAngle: 180.0 },
  };
  return Object.freeze(transitionSpec);
}

export const transitionMap = function getTransition(key) {
  let transitionSpec = null;
  switch (key) {
    case "dissolve": //fade
      transitionSpec = GLTransitions[38];
      break;

    case "push_right": //Directional
      transitionSpec = getPushRight();
      break;

    case "push_left": //Directional
      transitionSpec = getPushLeft();
      break;

    case "push_bottom": //Directional
      transitionSpec = getPushBottom();
      break;

    case "push_top": //Directional
      transitionSpec = getPushTop();
      break;

    case "simple_zoom": //SimpleZoom
      transitionSpec = GLTransitions[20];
      break;

    case "smooth_wipe_left": //linearWipe
      transitionSpec = GLTransitions[64];
      break;

    case "smooth_wipe_right": //linearWipe
      transitionSpec = GLTransitions[65];
      break;

    case "smooth_wipe_top": //linearWipe
      transitionSpec = GLTransitions[66];
      break;

    case "smooth_wipe_bottom": //linearWipe
      transitionSpec = GLTransitions[63];
      break;

    case "circle_open": //circleopen
      transitionSpec = GLTransitions[29];
      transitionSpec.defaultParams = { opening: true, smoothness: 0 };
      break;

    case "radial": //angular
      // transitionSpec = GLTransitions[25];
      transitionSpec = getRadial();
      break;

    case "Directional":
      transitionSpec = GLTransitions[8];
      break;

    case "doorway_open_horizontal":
      transitionSpec = GLTransitions[37];
      transitionSpec.defaultParams = {
        reflection: 0.0,
        depth: 0.0,
        perspective: 0.0,
      };
      break;

    default:
      transitionSpec = GLTransitions[8];
      transitionSpec.defaultParams.direction = [0, 0];
      break;
  }
  return transitionSpec;
};
